<template>
  <div id="app">
    <div :class="{ blur: isShowVerifyPage }">
      <keep-alive
        include="MusicList,Bill,Register,Home,AgentHome,Advisory,AgentBill"
      >
        <router-view></router-view>
      </keep-alive>
      <mr-footer></mr-footer>
    </div>

    <van-overlay :show="loading">
      <div class="loading">
        <van-loading type="spinner" vertical
          ><span class="color-fff">加载中...</span></van-loading
        >
      </div>
    </van-overlay>
    <van-number-keyboard safe-area-inset-bottom />
    <verify-page v-if="isShowVerifyPage"></verify-page>
  </div>
</template>

<script>
import MrFooter from "@/components/Footer";
import { mapState, mapMutations } from "vuex";
import VerifyPage from "@/pages/verify-page/index";
export default {
  name: "App",
  components: { MrFooter, VerifyPage },
  computed: {
    ...mapState([
      "loading",
      "currentRole",
      "userInfo",
      "isPlus",
      "isShowVerifyPage",
    ]),
  },
  watch: {
    $route() {
      if (window._czc) {
        let location = window.location;
        let contentUrl = location.pathname + location.hash;
        let refererUrl = "/";
        window._czc.push(["_setAutoPageview", false]);
        window._czc.push(["_trackPageview", contentUrl, refererUrl]);
      }
    },
  },
  mounted() {
    const script = document.createElement("script");
    script.src =
      "https://v1.cnzz.com/z_stat.php?id=1280220864&web_id=1280220864";
    script.language = "JavaScript";
    document.body.appendChild(script);
    const currentRole = localStorage.getItem("currentRole");
    currentRole && this.SET_ROLE(Number(currentRole));
    window.addEventListener("unload", () => {
      localStorage.setItem("currentRole", this.currentRole);
    });
  },
  methods: {
    ...mapMutations(["SET_ROLE", "TOGGLE_VERIFY"]),
  },
};
</script>

<style lang="scss" scoped>
.loading {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}
.blur {
  filter: blur(5px);
}
</style>
<style>
.van-overlay {
  z-index: 998 !important;
}
</style>
